import React, { useMemo } from "react";
import "./storeMapEmbed.css";
var getAddressQuery = function (args) {
    var segments = [args.address, args.city, args.state, args.zip]
        .map(function (segment) { return String(segment || "").trim(); })
        .filter(function (segment) { return segment.length > 0; });
    return segments.join(", ");
};
export var StoreMapEmbed = function (_a) {
    var name = _a.name, address = _a.address, city = _a.city, state = _a.state, zip = _a.zip, className = _a.className;
    var addressQuery = useMemo(function () {
        return getAddressQuery({ name: name, address: address, city: city, state: state, zip: zip });
    }, [name, address, city, state, zip]);
    if (!addressQuery) {
        return null;
    }
    var embedUrl = "https://maps.google.com/maps?q=".concat(encodeURIComponent(addressQuery), "&output=embed");
    var title = name ? "Map for ".concat(name) : "Store map";
    return (React.createElement("div", { className: ["store-map-embed", className].filter(Boolean).join(" ") },
        React.createElement("iframe", { src: embedUrl, title: title, className: "store-map-embed-frame", loading: "lazy", referrerPolicy: "no-referrer-when-downgrade", "aria-label": title, height: 125 })));
};
